import { Style } from '~src/style';

// Fallback hex for DesignTokens.color.feedback.default.error_light, used as the
// second argument to applyColor wherever the conflict tint is painted (table
// row, status badge, projects popover, dialog banner, project-tree node). Kept
// in one place so every conflict surface reads identically when CSS variables
// are unavailable. Matches the token's own light-theme value (#feded8).
export const ERROR_LIGHT_FALLBACK = '#feded8';

// Keyboard-only focus ring shared by the interactive triggers in the routing
// filter table (the status badge and the projects-info button). Spread into a
// style's `$nest` so both stay in sync (WCAG 2.4.7).
export const focusVisibleOutlineNest: Style['$nest'] = {
  '&:focus-visible': {
    outline: '2px solid currentColor',
    outlineOffset: '1px',
  },
};
